<template>
<div class="ceList">
    <a style='display: none' href='' id='share'></a>
</div>
</template>

<script>
/* eslint-disable */
export default {
    components: {
    },
    data() {
        return {

        }
    },
    created() {
        var GatherId = this.$route.query.gatherId
        var url = "http://cloud.jacoo.cn/api/gather/getsummary?gatherId="+GatherId
        this.$ajax.get(url)
            .then(res => {
                console.log(res.data);
                if (res.data.RspCode == 0) {
                    document.getElementById('share').href = res.data.Data.ShareLink;
                    document.getElementById('share').click();
                } else {
                    Toast({
                        message: res.data.RspMsg,
                        position: 'middle',
                        duration: 3000
                    });
                }
            })
            .catch(error => {
                console.log(error)
            })
       
    },
    methods: {

    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/feiyi2/views/home/sharePage.vue